<template lang="pug">
  .lang( :class="dark ? null : 'lang_color_grey'" )
      .lang__container
          .lang__container-img
              img(src="@/assets/images/ru.png", alt="", :class="{'lang__img-activ': lang === 'ru'}", class="lang__img lang__img-ru", v-on:click="ru")
              img(src="@/assets/images/en.png", alt="", :class="{'lang__img-activ': lang === 'en'}", class="lang__img lang__img-en", v-on:click="en")
              img(src="@/assets/images/ua.png", alt="", :class="{'lang__img-activ': lang === 'ua'}", class="lang__img lang__img-ua", v-on:click="ua")
              img(src="@/assets/images/kz.png", alt="", :class="{'lang__img-activ': lang === 'kz'}", class="lang__img lang__img-kz", v-on:click="kz")
              img(src="@/assets/images/mexico.png", alt="", :class="{'lang__img-activ': lang === 'es'}", class="lang__img lang__img-kz", v-on:click="es")
          img.lang__arrow(src="@/assets/images/arrow.png", alt="")
</template>

<script>
export default {
  data () {
    return {
      section: 'header'
    }
  },
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .lang {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    cursor: pointer;

    display: flex;
    align-items: center;

    width: 80px;

    padding-top: 30px;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 10px;

    border-radius: 3px;
    border: solid 1px rgba(248, 91, 5, 1);
    background-color: rgba(248, 91, 5, 0.9);

    z-index: 10;

    &:hover .lang__container-img {
      display: flex;
    }

    &_color_grey {
      border: solid 1px #f0f0f0;
      background-color: #f9f9f9;
      z-index: 2;
    }

    &__container {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      width: 100%;

      &-img {
        display: flex;
        // position: absolute;
        flex-direction: column;
        // bottom: -60px;
      }

    }

    &__img {
      display: none;
      width: 31px;
      height: 20px;
      cursor: pointer;
      padding-top: 20px;
    }

    &__img-activ {
      display: block;
      position: absolute;
      top: 10px;
      left: 12px;
      padding: 0 !important;
    }

    &__arrow {
      position: absolute;
      top: 18px;
      left: 54px;

      width: 10px;
      height: 5px;
    }

    &:hover .lang__img {
      display: flex;

    }

  }

  .lang_color_grey .lang__arrow {
    filter: invert(100%);
  }
</style>
